










export default
  name: 'ManageRow'

  components: {
  }

  props:
    label:
      type: String
      default: ''
    notice:
      type: String
      default: ''
    show_underline:
      type: Boolean
      default: false
    is_label_large:
      type: Boolean
      default: false
    is_must:
      type: Boolean
      default: false
    is_label_large_over:
      type: Boolean
      default: false
    is_column:
      type: Boolean
      default: false
    large_margin:
      type: Boolean
      default: false
    no_padding_right:
      type: Boolean
      default: false
